export default () => ({
  dialog: { width: '25rem', maxHeight: '31.25rem' },
  root: { paddingTop: '1.25rem', paddingBottom: '0.938rem' },
  boxButtons: {
    marginRight: '0.5rem',
    marginBottom: '0.5rem',
  },
});
